import { readSocialPostDraftCard } from '@wix/ai-scheduling-assistant-common-lib/entities';
import { readDraftPreviewCard, type DraftPreviewCardData } from './draft-preview';

export function readDraftCard(metadata: unknown): DraftPreviewCardData | null {
  const card = readDraftPreviewCard(metadata);
  if (card?.kind !== 'SOCIAL_POST') return card;
  const post = readSocialPostDraftCard((metadata as { draftPreviewCard?: { post?: unknown } }).draftPreviewCard?.post);
  return post && post.draftId.toLowerCase() === card.draftId.toLowerCase() ? { ...card, post } : null;
}
